import React from 'react';
import { useTranslation } from 'react-i18next';

import SectionTitle from '../../components/SectionTitle/SectionTitle';

import './Services.scss';

import ServicesData from './ServiceData';

import Service from '../../components/Service/Service';

import { Link } from 'react-router-dom';

import { BsFillArrowRightCircleFill } from 'react-icons/bs';

const Services = () => {
    const { t } = useTranslation();

    return (
        <section
            className="service-section pt-100 pb-70"
            data-aos="fade-up"
            data-aos-duration="2000"
        >
            <div className="container">

                <div className="row">

                    <div className="col-lg-6 col-sm-6">
                        <SectionTitle
                            title={t('servicesPreview.title')}
                            subTitle={t('servicesPreview.subTitle')}
                        />
                    </div>

                    <div className="col-lg-6 col-sm-6">
                        <p className="service-title-text">
                            {t('servicesPreview.description')}
                        </p>
                    </div>

                </div>

                <div className="row">

                    {ServicesData.map((singleService) => (
                        <Service
                            key={singleService.key}
                            serviceList={{
                                icon: singleService.icon,
                                title: t(
                                    `servicesPreview.items.${singleService.key}.title`
                                ),
                                description: t(
                                    `servicesPreview.items.${singleService.key}.description`
                                )
                            }}
                        />
                    ))}

                </div>

            </div>

            <div className="services-link text-center">

                <Link to="/singleservice">
                    {t('servicesPreview.more')}
                    <BsFillArrowRightCircleFill />
                </Link>

            </div>

        </section>
    );
};

export default Services;